import { createContext, useContext } from 'react';
import { CastRemotePlayer, CastSender, CastContext as CastContextType } from './interfaces';

export interface CastContextValues {
  sender: CastSender | undefined;
  context: CastContextType | undefined;
  player: CastRemotePlayer | undefined;
  isPending: boolean;
}

export const CastContext = createContext<CastContextValues | null>(null);

export function useCastContext() {
  const context = useContext(CastContext);

  if (context === null) {
    throw new Error('useCastContext must be used within a CastProvider');
  }

  return context;
}
